import { useState, useEffect, useRef, useCallback } from 'react';
import CreateNewRequisition from "./CreateNewRequisition";
import AssetTypeDispatch from '../../../../../Store/AssetManagement/AssetType/AssetTypeDispatch'
import CostCenterDispatch from '../../../../../Store/AssetManagement/CostCenter/CostCenterDispatch'
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { useDispatch, useSelector } from 'react-redux';
import { resetOrderRequest } from 'client/utils/RequisitionUtil';
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import { APIToReact } from 'Service/OrderManagement/ObjectStructure';
import { useParams } from 'react-router-dom';
import OrderDispatch from '../../../../../Store/OrderManagement/Order/OrderDispatch';
import { operations } from '../../../../../redux/Navigation';
import { popupInitialData } from 'utils';
import TransferAction from 'Store/Component/Transfer/TransferAction';
import { CONSTANTS } from 'client/utils/constants';

const CreateNewRequisitionContainer = (props: any) => {

  const setShowCatalog = props?.setShowCatalog
  const fieldRef = useRef<any>(null);
  /// dispatch
  const dispatch = useDispatch();
  const dispatchRequisitionTypeDropdown = AssetTypeDispatch.dispatchGetAssetType(dispatch);
  const dispatchBranchDropdown = CostCenterDispatch.dispatchGetCostCenter(dispatch);  
  const getOrderDetailById = OrderDispatch.dispatchGetOrderById(dispatch)
  const dispatchNav = operations.dispatchNav(dispatch);

  // Declarations
  const [requisitionType, setRequisitionType] = useState<any>('');
  const [branchValue, setBranchValue] = useState<any>({});
  const [branchTypeDropdownList, setBranchTypeDropdownList] = useState([]);
  const [branchValueTemp, setBranchValueTemp] = useState<String>('');
  const [expandedItems, setExpandedItems] = useState<any>([]);
  const setShowCart = props.setShowCart;
  const [selectRequisitionType, setSelectRequisitionType] = useState<any>('');
  const [isRequisitiontypeSelected, setIsRequisitionTypeSelected] = useState<any>(false);
  const [isAddItemClick, setIsAddItemClick] = useState<any>(false);

  ///selectors
  const { 
    requisitionTypeDropdown,
    branchTypeDropdown,
    activeNavigation,
    showItemDetails,
    orderId,
    orderBranch,
    isEditOrder,
    orderByIdValue,
    editRequestDetails,
    isEditRequestClick,
    isAddRequistionTypeClick,
    getUserDetails,
    isCostCenterAvailableForSubmit
  }: any = useSelector((state?: any) => ({
    requisitionTypeDropdown: state.AssetManagement.AssetType,
    branchTypeDropdown: state.CostCenter.costCenterDropDown,
    activeNavigation: state.GetBranchDetails.BranchDetails,
    showItemDetails: state.RequisitionReducer.showItemDetails,
    orderId: state.RequisitionReducer.orderId,
    orderBranch: state.RequisitionReducer.selectedBranch,
    isEditOrder: state.RequisitionReducer.isEditOrder,
    orderByIdValue: state.OrderReducer.orderByIdData,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
    isAddRequistionTypeClick: state.RequisitionReducer.isAddRequistionTypeClick,
    getUserDetails: state.UserProfile.getUserDetails,
    isCostCenterAvailableForSubmit: state.TransferReducer.isCostCenterAvailableForSubmit
  }));
  let { id } = useParams(); //this id is orderId for draft mode
  let { orderflow } = useParams();

  useEffect(() => {
    if(id != undefined)
    {
      dispatch(RequisitionAction.setOrderId(id));
      dispatch(RequisitionAction.setIsEditOrder(true));
      getOrderDetailById(id);
      if(orderflow == "orderDetails")
      {
        dispatchNav('MyOrderDetail')
      }
    }else{
      dispatch(RequisitionAction.setIsDealerSameForAllFlagFlag(false))
    }
  }, [])

  useEffect(() => {
    if(getUserDetails?.emailId) {
      dispatchRequisitionTypeDropdown();
      dispatchBranchDropdown(getUserDetails?.emailId);
    }
  }, [getUserDetails?.emailId])

  useEffect(() => {
    if (id) {
      if(orderByIdValue?.orderId == id){
      APIToReact({
        dispatch,
        orderByIdValue
      });
    }
    }else{
      dispatch(RequisitionAction.setIsDealerSameForAllFlagFlag(false))
    }
  }, [orderByIdValue]);

  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);

  ///Modified dropDown values as required
  const requisitionTypeDropdownList = requisitionTypeDropdown?.map((item: any, index: number) =>
    ({ text: item.orderRequestTypeId, label: item.orderRequestType, value: item.orderRequestType, key: (index == 0 ? null : index.toString()) })
  );
  const clearOrderDetailsOnBranchChange = () => {

    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: <><p>Are you sure to change Branch?</p><p>Already entered details will be removed.</p></>,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
    });

  }

  useEffect(() => {
    const branchTypeDropdownListTemp = branchTypeDropdown?.map((item: any, _index: number) =>
      ({ value: (item.branchName), label: ((item.costCenter ? (item.costCenter + " - ") : "") + item.branchName), text: item.branchNo, costCenter: item.costCenter })
    );
    setBranchTypeDropdownList(branchTypeDropdownListTemp);
    if (id !== undefined && Number(id) !== 0){
      setBranchValue(orderBranch);
    } else {
      branchTypeDropdownListTemp?.map((branchItem?: any, index?: any) => {
        let branchName = branchItem?.value;
        if (branchName === activeNavigation.name && branchItem?.costCenter === activeNavigation?.branchNumber) {
            if (requisitionType !== "" && (branchValue?.label?.split("-")[1].trim() !== activeNavigation.name)) {
            setBranchValueTemp(branchItem);
            clearOrderDetailsOnBranchChange();
          } else {
            setBranchValue(branchItem);
            dispatch(RequisitionAction.setSelectedBranch(branchItem));
          }
        }
      })
    }
  }, [activeNavigation,orderId,branchTypeDropdown])

  useEffect(() => {
    if (id) {
      if (branchTypeDropdown?.length && orderBranch?.branchName) {
        if (branchTypeDropdown?.filter((branchItem: any) => branchItem?.branchName === orderBranch?.branchName).length > 0) {
          dispatch(TransferAction?.setIsCostCenterAvailableForSubmit(true))
        } else {
          dispatch(TransferAction?.setIsCostCenterAvailableForSubmit(false))
        }
      }
    } else {
      dispatch(TransferAction?.setIsCostCenterAvailableForSubmit(true))
    }
  }, [branchTypeDropdown, orderBranch])

  useEffect(()=> {
    if(!props.mobile) {
      document.getElementsByClassName('vehicleTypeAccord')[0]?.classList?.remove('addedHeight');
    }
  },[props.mobile])

  useEffect(()=> {

   if(props.mobile && requisitionType?.value && branchValue.value) {
     setTimeout(()=> {
       if(!showItemDetails) {
       document.getElementsByClassName('vehicleTypeAccord')[0].classList.add('addedHeight');
       }
       const elem = document.getElementsByClassName('vehicleTypeAccord')[0] as HTMLElement;
       const top = elem?.offsetTop;
       document.getElementsByClassName('content-wrapper')[0].scrollTop = top;
     },500)
   }
  },[props.mobile,requisitionType,branchValue])

  const branchOnChange = (e: any, selectedItem: any) => {
    if(requisitionType !== "" && (branchValue?.label.split("-")[1].trim() !== selectedItem.label.split("-")[1].trim())) {
      clearOrderDetailsOnBranchChange();
      setBranchValueTemp(selectedItem);
    } else {
        setBranchValue(selectedItem);
        dispatch(RequisitionAction.setSelectedBranch(selectedItem));
      
      fieldRef.current?.focus();
      setRequisitionType("");
      dispatch(RequisitionAction.setSelectedRequisitionType(""));
      setExpandedItems("");
    }
  }

  const requisitionTypeOnChange = (e: any, selectedItem: any) => {
    
    setSelectRequisitionType(selectedItem);
    setIsRequisitionTypeSelected(true)
  };

  const onAddItemClick = () => {
    setIsAddItemClick(true)
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsAddRequistionTypeClick(true))
    if(selectRequisitionType){
      setIsRequisitionTypeSelected(true)
    }else{
      setIsRequisitionTypeSelected(false)
    }
    setRequisitionType(selectRequisitionType);
    requisitionTypeDropdown?.map((item?: any) => {
      if (item.orderRequestType === selectRequisitionType.value) {
        dispatch(RequisitionAction.setSelectedRequisitionType(item))
      }
    });
    dispatch(RequisitionAction.setIsAddItemclick(false))
  }

useEffect(() => {
  if(requisitionType?.label != CONSTANTS.MANAGED_EQUIPMENT){
    setShowCatalog(false)
  }else{
   dispatch(RequisitionAction.setSelectedEquipmentType({label : 'Select Equipment Type', text:null, value: null}))
  }
},[requisitionType])

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    []
  );
  
  const popupPrimarybtnOnclick = () => {
    setBranchValue(branchValueTemp);
    dispatch(RequisitionAction.setSelectedBranch(branchValueTemp));
    dispatch(RequisitionAction.setSelectedRequisitionType(""));
    setSelectRequisitionType("")
    resetOrderRequest(dispatch);
    setRequisitionType("");
    setShowCart(false);
    hideDialog();
  };

  const popupOutlinebtnOnclick = () => {
    hideDialog();
  };

  useEffect(() => {
     document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
  }, [activeNavigation]);
  useEffect(() => {
    document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsAddRequistionTypeClick(false))
 }, []);


 //Edit request types

 const [isEditRequestTypeClicked, setIsEditRequestTypeClicked] = useState<any>(false)

useEffect(() => {
  if(editRequestDetails?.requestType !== "" && editRequestDetails?.requestType !== undefined){
    setIsEditRequestTypeClicked(true)
    setRequisitionType({key : editRequestDetails?.requestIndex, label : editRequestDetails.requestType, text : editRequestDetails.orderRequestTypeId, value : editRequestDetails.requestType});
    requisitionTypeDropdown?.map((item?: any) => {
      if (item.orderRequestType === editRequestDetails.requestType) {
        setIsAddItemClick(true)
        setIsRequisitionTypeSelected(true)
        
        dispatch(RequisitionAction.setSelectedRequisitionType(item))
      }
    });
  }
}, [editRequestDetails]);

useEffect(() => {
  if(!isEditRequestClick && !isAddRequistionTypeClick){
    setRequisitionType("")
  }
},[isEditRequestClick])

  return (
    <CreateNewRequisition
      requisitionTypeDropdownList={requisitionTypeDropdownList}
      requisitionType={requisitionType}
      branchOnChange={branchOnChange}
      branchTypeDropdownList={branchTypeDropdownList}
      branchValue={branchValue}
      requisitionTypeOnChange={requisitionTypeOnChange}
       handleClickAdd={props.handleClickAdd}
      //defaultBranchValue = {defaultBranchValue}      
      setItemDetailComponent={props.setItemDetailComponent}
      mobile ={props.mobile}
      popupPrimarybtnOnclick={popupPrimarybtnOnclick}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      hideDialog={hideDialog}
      Popupcontent={Popupcontent}
      fieldRef={fieldRef}
      isEditOrder={isEditOrder}
      setShowCatalog={setShowCatalog}
      expandedItems={expandedItems}
      onAddItemClick={onAddItemClick}
      selectRequisitionType={selectRequisitionType}
      isRequisitiontypeSelected  = {isRequisitiontypeSelected}
      isAddItemClick = {isAddItemClick}
      isEditRequestTypeClicked = {isEditRequestTypeClicked}
      orderByIdValue = {orderByIdValue}
      isCostCenterAvailableForSubmit = {isCostCenterAvailableForSubmit}
    />
  )
}

export default CreateNewRequisitionContainer;